<template>
    <div class="form-input-group">
        <el-date-picker
            v-model="p_value.from"
            type="date"
            format="DD/MM/YYYY"
            value-format="MM/DD/YYYY"
        />
        <el-date-picker
            v-model="p_value.to"
            :disabled="!p_value.from"
            :disabled-date="disabledDateTo"
            type="date"
            format="DD/MM/YYYY"
            value-format="MM/DD/YYYY"
        />
    </div>
</template>

<script>
export default {
    name: "Period",
    props: {
        modelValue: {
            type: Object,
            required: true,
        }
    },
    data() {
        return {
            p_value: {
                from: null,
                to: null,
            },
        }
    },
    methods: {
        disabledDateFrom(datetime) {
            return datetime >= new Date();
        },
        disabledDateTo(datetime) {
            return datetime < new Date(this.p_value.from);
        },
    },
    created() {
        this.p_value = this.modelValue;
    },
    watch: {
        p_value: {
            handler(val) {
                this.$emit('update:modelValue', val);
            },
            deep: true,
        },
        ['p_value.from'](val) {
            if (!val) {
                this.p_value.to = null;
            }
        },
    }
}
</script>
